import axios from "axios";

export function deleteVoucher({ uuid, voucherUuid }) {
  return new Promise((resolve, reject) => {
    axios.post(`/consumer/admin/api/v1/survey/vouchers/delete`, {
      survey_uuid: uuid,
      voucher_uuid: voucherUuid,
    })
      .then(response => resolve(response.data))
      .catch(error => reject(error.response.data))
  })
}
